import { IRequestOptions, IResponseResult } from 'models/api.model'
import { IGeoDataResponse } from 'models/geo.model'
import { RequestMethod } from 'root-constants'
import { ApiService } from 'services/api.service'

export class GeoApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getGeoData(): Promise<IResponseResult<IGeoDataResponse>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      credentials: 'same-origin',
    }

    return this.api.makeCustomRequest<IResponseResult<IGeoDataResponse>>(
      'geo.meganove8.com',
      options,
    )
  }
}
